(() => {
  const ADDON_SELECTOR = 'cradri-shopping-bag-addon[data-bag-available="true"]';

  function getAddon(form) {
    const formId = form?.getAttribute('id');

    if (!formId) return null;

    return Array.from(document.querySelectorAll(ADDON_SELECTOR)).find(
      (addon) => addon.dataset.formId === formId
    );
  }

  function itemFromForm(formData) {
    const item = {
      id: Number(formData.get('id')),
      quantity: Number(formData.get('quantity') || 1),
    };
    const sellingPlan = formData.get('selling_plan');
    const properties = {};

    if (sellingPlan) item.selling_plan = Number(sellingPlan);

    for (const [name, value] of formData.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);

      if (match && value !== '') properties[match[1]] = value;
    }

    if (Object.keys(properties).length > 0) item.properties = properties;

    return item;
  }

  function setBusy(form, isBusy) {
    for (const button of form.querySelectorAll('[type="submit"]')) {
      if (isBusy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }
  }

  function showError(addon, message) {
    const status = addon.querySelector('.cradri-shopping-bag-addon__status');

    if (!status) return;
    status.dataset.status = 'error';
    status.textContent = message;
    status.hidden = false;
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('.cradri-shopping-bag-addon__checkbox');

    if (!checkbox) return;

    const addon = checkbox.closest('cradri-shopping-bag-addon');
    const quantity = addon?.querySelector('.cradri-shopping-bag-addon__quantity');
    const status = addon?.querySelector('.cradri-shopping-bag-addon__status');

    if (quantity) quantity.hidden = !checkbox.checked;
    if (status) status.hidden = true;
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    const addon = getAddon(form);
    const checkbox = addon?.querySelector('.cradri-shopping-bag-addon__checkbox');

    if (!form || !addon || !checkbox?.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);
    const quantity = Number(addon.querySelector('.cradri-shopping-bag-addon__select')?.value || 1);
    const sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections },
      })
    );

    setBusy(form, true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      const mainItem = itemFromForm(formData);
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            mainItem,
            { id: Number(addon.dataset.bagVariantId), quantity },
          ],
          sections: sections.join(','),
          sections_url: `${Shopify.routes.root}variants/${mainItem.id}`,
        }),
      });
      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || responseJson.message || 'カートに追加できませんでした。');
      }

      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cart = await fetch(`${Shopify.routes.root}cart.js`).then((cartResponse) => cartResponse.json());
      cart.sections = responseJson.sections;

      form.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.items || [],
            cart,
            onSuccessDo: formData.get('on_success'),
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: formData.get('on_success'),
            cart,
          },
        })
      );
    } catch (error) {
      const message = error instanceof Error ? error.message : 'カートに追加できませんでした。';

      showError(addon, message);
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: message } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      setBusy(form, false);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }, true);
})();
